export const APP_CONFIG = {
  NAME: 'DGL App',
  VERSION: '1.0.0',
  BASE_URL: process.env.REACT_APP_BASE_URL || 'https://sandsengineering.org',
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'https://api.dglofmadras.org/api',
  // API_BASE_URL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api',
  TOKEN_KEY: 'idToken',
  THEME_KEY: 'theme-mode',
} as const;

export const USER_ROLES = {
  Booking_SuperAdmin: 'Booking_SuperAdmin',
  Booking_Admin: 'Booking_Admin',
  Booking_Viewer: 'Booking_Viewer',

} as const;

export const COMPONENT_SIZE_LIMIT = 500

export const ENUMS = {
  PARTY_TYPE: ["supplier", "business", "store"],

  TXN_TYPE: ["purchase", "sale", "transfer"],

  PAYMENT_MODE: ["cash", "bank", "upi", "cheque"],

  LOCATIONS: [
    "supplier",
    "central",
      "business",
  ],
   LOCATIONS_TRANSFER_FROM: [
    // "supplier",
    "central",
 
  ],
     LOCATIONS_TRANSFER_TO: [
    "supplier",
    "central",
    "store-001",
    "store-002",
  ],


  LOG_TYPE: ["in", "out"]
} as const;

export type PartyType = typeof ENUMS.PARTY_TYPE[number];
export type TxnType = typeof ENUMS.TXN_TYPE[number];
export type PaymentMode = typeof ENUMS.PAYMENT_MODE[number];
export type Location = typeof ENUMS.LOCATIONS[number];
export type LogType = typeof ENUMS.LOG_TYPE[number];